import React from 'react'

import List from '@material-ui/core/List'


import {
    HomePlaces, ProfilePlaces,
} from './navigation-places'
import { ReactFC } from '../types'
import { useAppDrawerStyles } from '../navigation-ui/drawer'
import {  NavigationSubMenu } from './navigation-items'
import clsx from 'clsx'

export const ProfileSubMenu: ReactFC = () => {
    return <NavigationSubMenu places={ProfilePlaces} />
}

export const HomeSubMenu: ReactFC = () => {
    return <NavigationSubMenu places={HomePlaces} />
}

export const QuickLinks: ReactFC<{ className?: string }> = ({ children, className }) => {
    const classes = useAppDrawerStyles()

    return (
        <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            className={clsx(classes.root, className)}
        >
            {children}
        </List>
    )
}